import {
  CustomLabel,
  FlexContainer,
  Input,
  UtilityMethods,
} from "@mindmemobile/mm-shared-global";
import React from "react";
import styled from "styled-components";
import { AccountSettingsStore } from "../store";

type Props = {
  value: string;
  onChange: (value: string) => void;
  hasError?: boolean;
  errorMessage?: string;
  suggestedPrice?: number;
  className?: string;
};

export const CustomPricingWrapper = styled(FlexContainer)`
  flex-direction: column;
  align-items: center;
  gap: 10px;
  input {
    height: 53px;
    font-size: 24px;
    font-weight: 600;
    color: #aaa !important;
    width: 100%;
    &::placeholder {
      font-size: 24px;
      font-weight: 600;
      color: #aaa !important;
    }
  }
  label.full-width {
    text-align: left;
  }
  &.multiple-custom-pricing label.full-width {
    text-align: left !important;
    margin-left: 15px;
  }
`;

const CustomPricingInput: React.FC<Props> = ({
  value,
  onChange,
  hasError,
  errorMessage,
  suggestedPrice,
  className,
}) => {
  return (
    <CustomPricingWrapper className={className}>
      <Input
        type="text"
        value={value}
        placeholder="Enter Price"
        onChange={(e) => onChange(e.target.value)}
        error={hasError}
        errorMessage={errorMessage}
      />
      {!hasError && suggestedPrice !== undefined && suggestedPrice > 0 && (
        <CustomLabel className="full-width" textAlign="left" color="#556BB8">
          Suggested Price is $
          {`${AccountSettingsStore.formatAmount(suggestedPrice)}`}
        </CustomLabel>
      )}
    </CustomPricingWrapper>
  );
};

export default CustomPricingInput;
